import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, ChevronLeft, ChevronRight } from 'lucide-react';
export function BonusGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const bonuses = [{
    id: 1,
    badge: 'REGALO 1',
    title: 'Aromaterapia',
    description: 'El poder de los aromas para sanar cuerpo, mente y alma de forma natural.',
    image: 'https://cdn.magicpatterns.com/uploads/kGdaJ3Ee7c6dpFgGYvzgmY/Bonus_1_(hojas).webp',
    originalPrice: '12.000'
  }, {
    id: 2,
    badge: 'REGALO 2',
    title: 'Limpiezas Energéticas',
    description: 'Rituales ancestrales para purificar, proteger y elevar tu energía vital.',
    image: 'https://cdn.magicpatterns.com/uploads/nCyp3M5rkj2A8zvMLQMNo8/Bonus_2_(Hojas).webp',
    originalPrice: '10.000'
  }, {
    id: 3,
    badge: 'REGALO 3',
    title: 'SOS Antinflamación',
    description: 'Programa de 7 días para desinflamar tu cuerpo y recuperar tu bienestar.',
    image: 'https://cdn.magicpatterns.com/uploads/uwufkZ79bLnfLE4NyxEKXv/Bonus_3_(Hojas).webp',
    originalPrice: '15.000'
  }, {
    id: 4,
    badge: 'REGALO 4',
    title: 'Guía Herbal Femenina',
    description: 'Plantas medicinales clave para el equilibrio hormonal y bienestar femenino.',
    image: 'https://cdn.magicpatterns.com/uploads/mwfyJz6jXDiJrf8y7ivXWZ/Bonus_4_(Hojas).webp',
    originalPrice: '8.000'
  }, {
    id: 5,
    badge: 'REGALO 5',
    title: 'Botiquín Infantil',
    description: 'Remedios naturales seguros y efectivos para cuidar la salud de tus hijos.',
    image: 'https://cdn.magicpatterns.com/uploads/gpQX49cXuxkYaSZ3ujy9mz/Bonus_5_(Hojas).webp',
    originalPrice: '9.000'
  }];
  const scrollToIndex = (index: number) => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const card = container.children[0] as HTMLElement;
      const cardWidth = card.offsetWidth + 32; // card width + gap
      container.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const container = scrollRef.current;
      const card = container.children[0] as HTMLElement;
      const cardWidth = card.offsetWidth + 32;
      const newIndex = Math.round(scrollLeft / cardWidth);
      if (newIndex !== activeIndex) {
        setActiveIndex(newIndex);
      }
    }
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        const nextIndex = (activeIndex + 1) % bonuses.length;
        scrollToIndex(nextIndex);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [activeIndex, isAutoPlaying]);
  return <section id="bonuses" className="py-20 px-4 relative z-10 bg-transparent overflow-hidden border-y border-[#0f1711]/5 pt-[60px] pb-[60px]" data-id="element-85">
      <div className="max-w-7xl mx-auto" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#8b7355]/10 border border-[#8b7355]/30 text-sm font-black mb-6 tracking-widest uppercase text-[#0A791D]" data-id="element-88">
            <GiftIcon className="w-4 h-4" data-id="element-89" />
            OFERTA EXCLUSIVA: 5 REGALOS
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black mb-6 tracking-tight leading-tight text-[#171616]" data-id="element-90">
            TODO LO QUE <span className="text-[#8b7355]" data-id="element-91">TE LLEVÁS HOY</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl max-w-2xl mx-auto font-medium font-serif italic text-[#6C7688]" data-id="element-92">
            El Recetario Ancestral completo más 5 bonus exclusivos de regalo
          </motion.p>
        </div>

        <div className="relative group/carousel px-4" onMouseEnter={() => setIsAutoPlaying(false)} onMouseLeave={() => setIsAutoPlaying(true)} data-id="element-93">
          {/* Navigation Buttons */}
          <div className="absolute top-1/2 -left-4 md:-left-8 -translate-y-1/2 z-20" data-id="element-94">
            <button onClick={() => scrollToIndex(Math.max(0, activeIndex - 1))} disabled={activeIndex === 0} className={`p-4 rounded-full bg-white border border-[#0f1711]/10 text-[#0f1711] transition-all ${activeIndex === 0 ? 'opacity-30 cursor-not-allowed' : 'hover:border-[#8b7355] hover:text-[#8b7355] shadow-sm'}`} data-id="element-95">
              <ChevronLeft className="w-6 h-6" data-id="element-96" />
            </button>
          </div>

          <div className="absolute top-1/2 -right-4 md:-right-8 -translate-y-1/2 z-20" data-id="element-97">
            <button onClick={() => scrollToIndex(Math.min(bonuses.length - 1, activeIndex + 1))} disabled={activeIndex === bonuses.length - 1} className={`p-4 rounded-full bg-white border border-[#0f1711]/10 text-[#0f1711] transition-all ${activeIndex === bonuses.length - 1 ? 'opacity-30 cursor-not-allowed' : 'hover:border-[#8b7355] hover:text-[#8b7355] shadow-sm'}`} data-id="element-98">
              <ChevronRight className="w-6 h-6" data-id="element-99" />
            </button>
          </div>

          {/* Carousel Container */}
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar gap-8 pb-10" data-id="element-100">
            {bonuses.map((bonus, index) => <div key={bonus.id} className="min-w-full md:min-w-[calc(50%-16px)] lg:min-w-[calc(33.333%-22px)] snap-center" data-id="element-101">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="h-full w-full bg-[#f5f0e1] overflow-hidden transition-all duration-500 group flex flex-col border border-[#0f1711]/5 shadow-sm rounded-[2rem]" data-id="element-102">
                  <div className="relative w-full aspect-square overflow-hidden" data-id="element-103">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" data-id="element-104" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#f5f0e1]/20 via-transparent to-transparent opacity-30" data-id="element-105" />
                  </div>

                  <div className="p-6 md:p-8 flex flex-col flex-grow bg-[#f5f0e1]" data-id="element-106">
                    <div className="inline-flex self-start items-center gap-2 px-4 py-1.5 rounded-full bg-[#8b7355]/10 border border-[#8b7355]/30 font-black mb-4 tracking-widest uppercase text-[13px] text-[#160D02]" data-id="element-107">
                      {bonus.badge}
                    </div>

                    <h3 className="font-black text-xl md:text-2xl mb-3 leading-tight group-hover:text-[#8b7355] transition-colors text-[#312C2C]" data-id="element-108">
                      {bonus.title}
                    </h3>

                    <p className="text-base md:text-lg mb-6 leading-relaxed flex-grow font-medium text-[#933690]" data-id="element-109">
                      {bonus.description}
                    </p>

                    <div className="text-center mt-auto" data-id="element-110">
                      <p className="text-[#8b7355] text-xs font-bold mb-3 tracking-widest uppercase" data-id="element-111">
                        ¡REGALO EXCLUSIVO!
                      </p>
                      <div className="bg-[#1a2e1a] text-white font-black md:text-xl py-3 px-6 rounded-xl uppercase tracking-widest shadow-md transform group-hover:scale-105 transition-transform duration-300 text-[20px]" data-id="element-112">
                        GRATIS 🎁
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>)}
          </div>

          {/* Indicators */}
          <div className="flex justify-center gap-3 mt-4" data-id="element-113">
            {bonuses.map((_, index) => <button key={index} onClick={() => scrollToIndex(index)} className={`h-2.5 rounded-full transition-all duration-300 ${activeIndex === index ? 'w-10 bg-[#8b7355] shadow-sm' : 'w-2.5 bg-[#0f1711]/10 hover:bg-[#0f1711]/20'}`} data-id="element-114" />)}
          </div>
        </div>
      </div>
    </section>;
}